import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Icon } from 'b3';
import { createContact, updateContact } from '../actions/ClientActions';
import ClientContactForm from './ClientContactForm';

@connect(state => ({
    client: state.activeClient.client,
    isSaving: state.modal.isSavingContact
}))
export default class CreateContactsModal extends Component {
    getFormData() {
        this.refs.form.exposeFormData();
    }
    async onSubmit(formData) {
        if(this.props.isEditing) {
            this.props.dispatch(updateContact(this.props.contactId, formData));
        } else {
            if(this.props.onCreate) {
                var contactAction = await this.props.dispatch(createContact(this.props.clientId, formData));
                this.props.onCreate(contactAction.result.id);
            } else {
                this.props.dispatch(createContact(this.props.clientId, formData));   
            }
        }
    }
    handleClose() {
        console.log('close from here oi');
    }
    render() {
        var { isEditing } = this.props;

        var title = isEditing ? "Update Contact" : "Create Contact";

        return (
            <div>
                <div>
                    <Icon icon="user-add-2" />
                    <h2>{title}</h2>
                    <Icon onClick={this.handleClose.bind(this)} icon="cross" />
                </div>
                <ClientContactForm onSubmit={this.onSubmit.bind(this)} ref="form" {...this.props} />
            </div>    
        );
    }
}




// WEBPACK FOOTER //
// ./app/components/CreateContactModal.js